// app/javascript/controllers/chat_new_room_controller.js (complete)
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "participantList", "searchInput"]

  connect() {
    this.selectedUser = null

    // this.modalTarget.addEventListener('mousedown', event => {
    //   if (event.target === event.currentTarget) {
    //     event.currentTarget.close()
    //   }
    // });
  }

  openModal() {
    // this.modalTarget.classList.remove('hidden')
    this.modalTarget.showModal()
  }

  closeModal() {
    this.modalTarget.close()
    // this.modalTarget.classList.add('hidden')
    // document.body.classList.remove('modal-open')
    this.resetForm()
  }

  get userItems() {
    return this.participantListTarget.querySelectorAll('.user-item')
  }

  searchUsers(event) {
    const searchTerm = event.target.value.toLowerCase()

    this.userItems.forEach(item => {
      const userName = item.querySelector('.user-name').textContent.toLowerCase()
      item.classList.toggle('hidden', !userName.includes(searchTerm))
    })
  }

  resetUsers() {
    this.selectedUser = null
    this.userItems.forEach(item => item.classList.remove('selected') )
  }

  toggleUser(event) {
    this.resetUsers()

    const userId = event.currentTarget.dataset.userId

      this.selectedUser = userId
      event.currentTarget.classList.add('selected')
  }

  submitForm(event) {
    event.preventDefault()

    if (this.selectedUser == null) {
      console.log('No selected user')
      return;
    }

    // Add selected participant IDs to form data
    const form = event.target || event.target.closest('form');
    const existingInputs = form.querySelectorAll('input[name="user_id"]')
    existingInputs.forEach(input => input.remove())

    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = 'user_id'
    hiddenInput.value = this.selectedUser
    form.appendChild(hiddenInput)

    Turbo.navigator.submitForm(form)
  }

  resetForm() {
    this.selectedUser = null
    // this.selectedParticipantsTarget.innerHTML = ''

    // Reset user item selections
    this.participantListTarget.querySelectorAll('.user-item').forEach(item => {
      item.classList.remove('selected')
    })

    // Clear search
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
      // Show all users again
      this.participantListTarget.querySelectorAll('.user-item').forEach(item => {
        item.classList.remove('hidden')
      })
    }
  }
}
